import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { GlowAuthService } from './services/glowadminservices/glowauth.service';
import { ApplicationSelectorService } from './services/app-selector.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'my-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    componentId: string = 'AppComponent';
    applicationId: string

    subscriptionAuth: Subscription;

    constructor(
        private glowAuthService: GlowAuthService,
        private appSelectorService: ApplicationSelectorService,
        private router: Router) {
        this.subscriptionAuth = this.glowAuthService.getAuthEvent.subscribe(authEvent => {
            console.log(this.componentId + " authEvent " + authEvent)
            if (authEvent === "login") {
                console.log("Login emitted app component", authEvent)
                this.appSelectorService.selectDefaultApplication();
            } else {
                console.log("Navigating to login page " + authEvent)
                this.router.navigate(['login'])
            }
        });
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        if (this.subscriptionAuth) {
            this.subscriptionAuth.unsubscribe()
        }
    }
}
